module.exports = __webpack_public_path__ + "media/sephiroth.b72df52e.wav";